var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.7C19.4 13.7 19 14.1 19 14.7V20C19 20.6 18.6 21 18 21H4C3.4 21 3 20.6 3 20V6C3 5.4 3.4 5 4 5H9.3C9.9 5 10.3 4.6 10.3 4C10.3 3.4 9.9 3 9.3 3H4C2.3 3 1 4.3 1 6V20C1 21.7 2.3 23 4 23H18C19.7 23 21 21.7 21 20V14.7C21 14.1 20.6 13.7 20 13.7ZM22.7 5.3L18.7 1.3C18.3 0.9 17.7 0.9 17.3 1.3L7.3 11.3C7.1 11.5 7 11.7 7 12V16C7 16.6 7.4 17 8 17H12C12.3 17 12.5 16.9 12.7 16.7L22.7 6.7C23.1 6.3 23.1 5.7 22.7 5.3ZM11.6 15H9V12.4L18 3.4L20.6 6L11.6 15Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconEdit.0e98844edeb3f9e92d8f89178e35c2af.svg";